/* ECOM AI BUILDER — Theme JS (vanilla, léger) */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  // i18n : libellés dynamiques traduits depuis les fichiers de langue (via window.CartCfg.i18n), fallback EN
  function tr(k, d) { var i = (window.CartCfg && window.CartCfg.i18n) || {}; return i[k] || d; }

  /* ---------- Menu mobile ---------- */
  var menu = $('[data-mobile-menu]'), menuOverlay = $('[data-overlay]');
  function openMenu() { menu && menu.classList.add('is-open'); menuOverlay && menuOverlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { menu && menu.classList.remove('is-open'); menuOverlay && menuOverlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  var burger = $('[data-menu-toggle]');
  burger && burger.addEventListener('click', openMenu);
  menuOverlay && menuOverlay.addEventListener('click', closeMenu);
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });

  /* ---------- Quantité (+/-) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty-wrap]'), input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + (btn.dataset.qty === 'plus' ? 1 : -1);
    input.value = Math.max(1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Panier (AJAX + drawer) ---------- */
  var drawer = $('[data-cart-drawer]');
  var cartBody = $('[data-cart-items]');
  var cartFoot = $('[data-cart-foot]');
  var subtotalEl = $('[data-cart-subtotal]');
  var countEls = $$('[data-cart-count]');

  var R = window.Routes || {};
  var URL_ADD = (R.cartAdd || '/cart/add') + '.js';
  var URL_CART = (R.cart || '/cart') + '.js';
  var URL_CHANGE = (R.cartChange || '/cart/change') + '.js';

  function money(cents, cur) {
    var s = window.Shop || {};
    try { return new Intl.NumberFormat(s.locale || 'en', { style: 'currency', currency: cur || s.currency || 'USD' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeMenu(); } });

  function renderCart(cart) {
    countEls.forEach(function (e) { e.textContent = cart.item_count; e.style.display = cart.item_count ? '' : 'none'; });
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div class="drawer__empty">' + tr('empty', 'Your cart is empty') + '</div>';
      if (cartFoot) cartFoot.hidden = true;
      document.dispatchEvent(new CustomEvent('eab:cart', { detail: { cart: cart } })); // apps partagées (UpKart)
      return;
    }
    if (cartFoot) cartFoot.hidden = false;
    var cfg = window.CartCfg || {};
    cartBody.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + '&width=160" alt="">' : '<div></div>';
      var priceHtml;
      if (cfg.strike && it.original_line_price > it.final_line_price) {
        priceHtml = '<span class="dci__was">' + money(it.original_line_price, cart.currency) + '</span>' +
          '<span class="dci__now">' + money(it.final_line_price, cart.currency) + '</span>';
      } else {
        priceHtml = money(it.final_line_price, cart.currency);
      }
      return '<div class="dci" data-key="' + it.key + '">' + img +
        '<div><div class="dci__title">' + it.product_title + '</div>' +
        (it.variant_title ? '<div class="dci__variant">' + it.variant_title + '</div>' : '') +
        '<div class="dci__qty"><button type="button" data-line-minus aria-label="-">−</button><span>' + it.quantity + '</span><button type="button" data-line-plus aria-label="+">+</button></div>' +
        '<button type="button" class="dci__remove" data-line-remove>' + tr('remove', 'Remove') + '</button></div>' +
        '<div class="dci__price">' + priceHtml + '</div></div>';
    }).join('');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price, cart.currency);
    var savingsEl = $('[data-cart-savings]');
    if (savingsEl) {
      if (cfg.savings && cart.total_discount > 0) {
        savingsEl.hidden = false;
        savingsEl.innerHTML = '<span>' + tr('savings', 'You save') + '</span><strong>' + money(cart.total_discount, cart.currency) + '</strong>';
      } else {
        savingsEl.hidden = true;
      }
    }
    document.dispatchEvent(new CustomEvent('eab:cart', { detail: { cart: cart } })); // apps partagées (UpKart)
  }

  function addById(id, qty) {
    return fetch(URL_ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty || 1 }) })
      .then(function (r) { return r.json(); }).then(function () { return refresh(false); });
  }

  // Upsell / produits complémentaires : ajout (ouvre le tiroir pour confirmer)
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-upsell-add]');
    if (!up || up.disabled || up.closest('[data-eab-upcart]')) return;
    up.disabled = true; var old = up.textContent; up.textContent = '…';
    addById(parseInt(up.dataset.id, 10), 1).then(function () { up.textContent = old; up.disabled = false; openDrawer(); });
  });

  // --- Gifto : produit cadeau auto au seuil (config window.EABGift, theme.liquid).
  // Propriété _eab_gift sur la ligne cadeau (exclue du calcul), garde anti-boucle.
  var giftBusy = false;
  function giftSync(cart) {
    var G = window.EABGift; if (!G || !G.vid) return;
    var giftLine = null, others = 0;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === G.vid && it.properties && it.properties._eab_gift) giftLine = it;
      else others += it.final_line_price;
    });
    var over = others >= G.threshold;
    var msg = document.querySelector('[data-gift-msg]');
    if (msg) {
      if (over) { msg.textContent = G.unlocked; msg.hidden = false; }
      else if (others > 0) { msg.textContent = G.progress.replace('{amount}', (window.money ? money(G.threshold - others) : ((G.threshold - others) / 100).toFixed(2))); msg.hidden = false; }
      else { msg.hidden = true; }
    }
    if (giftBusy) return;
    if (over && !giftLine) {
      giftBusy = true;
      fetch(URL_ADD, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: G.vid, quantity: 1, properties: { _eab_gift: '1' } }) })
        .then(function () { giftBusy = false; refresh(false); }).catch(function () { giftBusy = false; });
    } else if (!over && giftLine && G.remove) {
      giftBusy = true;
      fetch(URL_CHANGE, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: giftLine.key, quantity: 0 }) })
        .then(function () { giftBusy = false; refresh(false); }).catch(function () { giftBusy = false; });
    }
  }

  // Contrat apps partagées : une app a modifié le panier -> re-rendre (+ ouvrir).
  document.addEventListener('eab:cart:refresh', function (e) {
    refresh(!!(e.detail && e.detail.open));
  });

  function refresh(openAfter) {
    return fetch(URL_CART, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); giftSync(cart); if (openAfter) openDrawer(); return cart; });
  }

  // Ajout au panier (intercepte le form produit)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"], [name="add"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = tr('adding', 'Adding…'); }
    fetch(URL_ADD, { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { var e = new Error(res.d.description || res.d.message || tr('error', 'Something went wrong')); e.handled = true; throw e; }
        return refresh(true).then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
      })
      .catch(function (err) {
        if (err && err.handled) {
          // Erreur produit (rupture, etc.) → message, on réactive le bouton
          alert(err.message);
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
        } else {
          // Échec réseau/JS → on laisse le navigateur soumettre le formulaire normalement (ajout garanti)
          form.submit();
        }
      });
  });

  // Modifier quantité / retirer dans le drawer
  document.addEventListener('click', function (e) {
    var line = e.target.closest('.dci');
    if (!line) return;
    var key = line.dataset.key;
    var qtyEl = line.querySelector('.dci__qty span');
    var q = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
    var newQ = null;
    if (e.target.closest('[data-line-plus]')) newQ = q + 1;
    else if (e.target.closest('[data-line-minus]')) newQ = Math.max(0, q - 1);
    else if (e.target.closest('[data-line-remove]')) newQ = 0;
    if (newQ === null) return;
    fetch(URL_CHANGE, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: newQ }) })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  });

  // Ouvrir le drawer depuis l'icône panier
  $$('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
  });

  /* ---------- Sélecteur langue / pays (footer) ---------- */
  document.addEventListener('change', function (e) {
    var loc = e.target.closest('[data-loc-auto]');
    if (loc && loc.form) loc.form.submit();
  });

  /* ---------- Filtres de collection (facets) ---------- */
  document.addEventListener('change', function (e) {
    var facets = e.target.closest('[data-facets]');
    if (facets) facets.submit();
  });

  /* ---------- Recherche prédictive ---------- */
  var ps = $('[data-psearch]');
  if (ps) {
    var psInput = ps.querySelector('[data-psearch-input]');
    var psResults = ps.querySelector('[data-psearch-results]');
    var psTimer = null, psSeq = 0;
    function psOpen() { ps.hidden = false; document.body.style.overflow = 'hidden'; setTimeout(function () { psInput && psInput.focus(); }, 30); $$('[data-psearch-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); }); }
    function psClose() { ps.hidden = true; document.body.style.overflow = ''; $$('[data-psearch-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
    $$('[data-psearch-toggle]').forEach(function (b) { b.addEventListener('click', function () { ps.hidden ? psOpen() : psClose(); }); });
    ps.addEventListener('click', function (e) { if (e.target.closest('[data-psearch-close]')) psClose(); if (e.target === ps) psClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ps.hidden) psClose(); });

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function psRender(data, q) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var base = ps.dataset.searchUrl || '/search';
      if (!products.length) {
        psResults.innerHTML = '<p class="psearch__empty">' + esc((ps.dataset.strNoResults || '').replace('%q%', q)) + '</p>';
      } else {
        psResults.innerHTML = products.map(function (p) {
          var iu = p.featured_image && p.featured_image.url;
          var img = iu ? '<img src="' + esc(iu + (iu.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="" loading="lazy">' : '<span class="psearch__noimg"></span>';
          return '<a class="psearch__item" href="' + esc(p.url) + '">' + img +
            '<span class="psearch__title">' + esc(p.title) + '</span>' +
            '<span class="psearch__price">' + esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span></a>';
        }).join('') +
        '<a class="psearch__all" href="' + esc(base) + '?q=' + encodeURIComponent(q) + '">' + esc(ps.dataset.strViewAll || '') + ' →</a>';
      }
      psResults.hidden = false;
    }
    psInput && psInput.addEventListener('input', function () {
      var q = psInput.value.trim();
      clearTimeout(psTimer);
      if (q.length < 2) { psResults.hidden = true; psResults.innerHTML = ''; return; }
      psTimer = setTimeout(function () {
        var seq = ++psSeq;
        var base = ps.dataset.searchUrl || '/search';
        fetch(base + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) { if (seq === psSeq) psRender(data, q); })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------- Animations d'apparition au scroll ---------- */
  if (document.body.classList.contains('anims') && 'IntersectionObserver' in window) {
    var animObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in-view'); animObs.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('main .shopify-section').forEach(function (sec) { animObs.observe(sec); });
    // Filet de securite : tout rendre visible apres 3s quoi qu'il arrive
    setTimeout(function () { $$('main .shopify-section').forEach(function (sec) { sec.classList.add('in-view'); }); }, 3000);
  } else {
    document.body.classList.remove('anims');
  }

  /* ---------- Menus footer : toujours ouverts sur desktop ---------- */
  var footMenus = $$('details.footer__menu');
  if (footMenus.length) {
    var footMq = matchMedia('(min-width: 750px)');
    var syncFoot = function () { if (footMq.matches) footMenus.forEach(function (d) { d.open = true; }); };
    syncFoot();
    footMq.addEventListener ? footMq.addEventListener('change', syncFoot) : footMq.addListener(syncFoot);
  }

  // État initial
  if (drawer) refresh(false);
})();
